import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import { useSelector } from 'react-redux';
import { BrokerClientApi } from '@apply/api';
import { applicationInsights } from '../../ApplicationInsights';
import store, { loanActions } from '@apply/adminStore';
import { hasPermission } from '@apply/ui';
import { PermissionType } from '@apply/constants';

const DealModal = ({ isOpen, submitCallback, cancelCallback }) => {
    const { brokerClientState } = useSelector((state) => state);
    const { dispatch } = store;
    const brokerClientApi = new BrokerClientApi.BrokerClientApi(applicationInsights);
    const selectTypes = {
        deal: 'deal',
        expire: 'expire',
        reject: 'reject',
        linkLoan: 'linkLoan',
    };

    const [rejectedComment, set_rejectedComment] = React.useState('');

    const [selectedRadioButton, set_selectedRadioButton] = React.useState();

    const _expireBroker = async () => await brokerClientApi.expireBrokerAgreement(brokerClientState.brokerClientId);

    const _rejectBroker = async () =>
        await brokerClientApi.rejectBrokerAgreement({
            id: brokerClientState.brokerClientId,
            comment: rejectedComment,
        });

    const _onSubmit = async (event) => {
        event.preventDefault();

        switch (selectedRadioButton) {
            case selectTypes.deal:
                dispatch(
                    loanActions.setEditStdLoanModal({
                        editStdLoanModal: {
                            isOpen: true,
                            bClientId: brokerClientState.brokerClientId,
                            showInsurance: false,
                        },
                    })
                );
                submitCallback();
                break;
            case selectTypes.expire:
                await _expireBroker();
                submitCallback();
                break;
            case selectTypes.reject:
                await _rejectBroker();
                submitCallback();
                break;
            case selectTypes.linkLoan:
                dispatch(
                    loanActions.setLinkLoanWithBClientModal({
                        linkLoanWithBClientModal: {
                            isOpen: true,
                            bClientId: brokerClientState.brokerClientId,
                        },
                    })
                );
                submitCallback();
                break;
            default:
                throw new Error(`An unknown radio button type was found: ${selectedRadioButton}`);
        }

        set_selectedRadioButton(undefined);
    };

    const _handleClose = () => {
        cancelCallback();
        set_selectedRadioButton(undefined);
    };

    const _onRadioButtonChange = (event) => {
        set_selectedRadioButton(event.target.value);
    };

    const styles = {
        buttonMarginRight: {
            marginRight: '20px',
        },
        noMargin: {
            margin: 0,
        },
        sideMargin: {
            marginRight: 20,
            marginLeft: 20,
        },
        modal: {
            width: 600,
        },
        autoHeight: {
            height: 'auto',
        },
    };

    const expireHtml = (
        <>
            <div>Confirm that this ICAA has expired, and move to expired ICCA.</div>
            <br />
        </>
    );

    const rejectHtml = (
        <div
            className='row'
            style={styles.noMargin}
        >
            <label
                htmlFor='rejectedComment'
                style={styles.label}
            >
                Reason for rejection:
                <span className='req'>*</span>
            </label>
            <textarea
                name='Text1'
                cols='40'
                rows='3'
                className='req'
                style={styles.sideMargin}
                value={rejectedComment}
                onChange={(event) => set_rejectedComment(event.target.value)}
                required
            />
        </div>
    );

    return (
        <Dialog
            maxWidth='lg'
            open={isOpen}
            onClose={_handleClose}
            aria-labelledby='form-dialog-title'
        >
            <div className='modal-container'>
                <div className='modal-backdrop'></div>
                <div
                    className='modal'
                    tabIndex='-1'
                    role='dialog'
                    style={styles.modal}
                >
                    <div
                        className='modal-dialog'
                        role='document'
                    >
                        <form
                            name='brokerForm'
                            onSubmit={(event) => _onSubmit(event)}
                        >
                            <div
                                className='page-header'
                                role='banner'
                            >
                                <h1>Update Client</h1>
                                <button
                                    type='button'
                                    className='close'
                                    data-dismiss='modal'
                                    aria-label='Close'
                                    onClick={_handleClose}
                                >
                                    <span aria-hidden='true'>&times;</span>
                                </button>
                            </div>
                            <div className='main-content no-search'>
                                <div
                                    className='scrollable-content'
                                    style={styles.autoHeight}
                                >
                                    <div className='standard-form'>
                                        <h2 className='decorated'>Select an action:</h2>
                                        <div
                                            className='row'
                                            style={styles.noMargin}
                                        >
                                            <div className='columns small-12 medium-6'>
                                                <div className='radio'>
                                                    <label>
                                                        <input
                                                            type='radio'
                                                            value={selectTypes.deal}
                                                            checked={selectedRadioButton === selectTypes.deal}
                                                            onChange={_onRadioButtonChange}
                                                        />
                                                        Add Deal
                                                    </label>
                                                </div>
                                                <div className='radio'>
                                                    <label>
                                                        <input
                                                            type='radio'
                                                            value={selectTypes.linkLoan}
                                                            checked={selectedRadioButton === selectTypes.linkLoan}
                                                            onChange={_onRadioButtonChange}
                                                        />
                                                        Link Loan to B-Client
                                                    </label>
                                                </div>
                                                <div className='radio'>
                                                    <label>
                                                        <input
                                                            type='radio'
                                                            value={selectTypes.expire}
                                                            checked={selectedRadioButton === selectTypes.expire}
                                                            onChange={_onRadioButtonChange}
                                                        />
                                                        Expire
                                                    </label>
                                                </div>
                                                <div className='radio'>
                                                    <label>
                                                        <input
                                                            type='radio'
                                                            value={selectTypes.reject}
                                                            checked={selectedRadioButton === selectTypes.reject}
                                                            onChange={_onRadioButtonChange}
                                                            disabled={!hasPermission(PermissionType.BClientApproveReject)}
                                                        />
                                                        Reject
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        {selectedRadioButton === selectTypes.reject && rejectHtml}
                                        {selectedRadioButton === selectTypes.expire && expireHtml}
                                    </div>
                                    <div className='button-footer'>
                                        <button
                                            style={styles.buttonMarginRight}
                                            type='submit'
                                            className='button primary'
                                            disabled={selectTypes[selectedRadioButton] === undefined}
                                        >
                                            Submit
                                        </button>
                                        <button
                                            type='button'
                                            className='button hollow'
                                            data-dismiss='modal'
                                            onClick={_handleClose}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </Dialog>
    );
};

export default DealModal;
